var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96.199997mm",
    height: "96.199997mm",
    viewBox: "0 0 96.199997 96.199997",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.28619,
    y: 132.619,
    width: 142.78329,
    height: 240.28841,
    id: "rect10"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0.1,0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff5d6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1",
    width: 96,
    height: 96,
    x: 0.099996947,
    y: -0.1,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.02509,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2-1",
    d: "M 44.709553,12.190748 A 31.201326,31.201326 0 0 1 75.910879,43.392075 H 44.709553 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 44.709551,12.190747 v 4.748788",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 44.709552,69.844614 v 4.748789",
    id: "path5-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 75.910879,43.392074 H 71.16209",
    id: "path5-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 18.257011,43.392074 H 13.508223",
    id: "path5-3-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 71.730693,27.79141 -4.11257,2.374394",
    id: "path5-20"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.719,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 21.80098,56.618345 17.688408,58.99274",
    id: "path5-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 59.781049,69.88405 57.406654,65.771479",
    id: "path5-3-5-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 31.483281,20.483503 29.108887,16.370932",
    id: "path5-3-0-39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 60.310215,16.370932 -2.374394,4.112571",
    id: "path5-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 31.625372,66.300647 -2.374394,4.112571",
    id: "path5-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 71.201525,58.463571 67.088959,56.089179",
    id: "path5-3-5-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#3d8ae2",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 21.80098,30.165805 17.688408,27.791411",
    id: "path5-3-0-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3d8ae2",
      strokeWidth: 3.49476,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 31.782561,31.01882 44.709552,43.392074",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3d8ae2",
      strokeWidth: 3.49476,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 45.676627,43.47807 11.842631,-0.086",
    id: "path4-9"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3d8ae2",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.42685,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3",
    cx: 0.87409234,
    cy: 62.277153,
    r: 3.3875301,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3d8ae2",
      strokeWidth: 3.84648,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2",
    cx: 44.709553,
    cy: 43.392075,
    r: 32.274128
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    style: {
      fill: "#ffc332",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.24031,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 66.164028,48.477273 a 6.2153915,6.2153915 0 0 0 -5.43313,3.230518 l -0.01936,-0.01034 -15.001324,25.982837 c 1.45e-4,-1.4e-4 0.01666,-0.01711 0.01666,-0.01711 l 0.01351,0.02432 a 6.2153915,6.2153915 0 0 0 -0.961277,3.275093 6.2153915,6.2153915 0 0 0 6.215208,6.215665 6.2153915,6.2153915 0 0 0 0.224672,-0.0099 H 81.323842 A 6.2153915,6.2153915 0 0 0 87.5395,80.953145 6.2153915,6.2153915 0 0 0 86.959133,78.330913 l 0.120664,0.149032 -15.297134,-26.495229 -0.02297,0.0027 -0.03871,0.01891 a 6.2153915,6.2153915 0 0 0 -5.556945,-3.529035 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "text10",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "'Gill Sans MT'",
      InkscapeFontSpecification: "'Gill Sans MT, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      textAlign: "end",
      whiteSpace: "pre",
      shapeInside: "url(#rect10)",
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.485435,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 599.60151,141.46755 c -2.70313,0 -4.05464,1.7268 -4.05464,5.17992 0,2.85937 0.39095,6.32004 1.1722,10.38254 0.79687,4.06249 1.31241,6.3675 1.54678,6.91437 0.23438,0.53125 0.67941,0.79685 1.33566,0.79685 0.60937,0 1.0544,-0.32044 1.33565,-0.96106 0.28125,-0.65625 0.78971,-3.12502 1.52408,-7.40626 0.75,-4.29687 1.12453,-7.53894 1.12453,-9.72644 0,-3.45312 -1.32802,-5.17992 -3.98426,-5.17992 z m 0,25.24273 c -1.15625,0 -2.14816,0.4137 -2.97628,1.24182 -0.8125,0.8125 -1.21912,1.78949 -1.21912,2.93012 0,1.15625 0.40662,2.14032 1.21912,2.95282 0.82812,0.81249 1.82003,1.21835 2.97628,1.21835 1.14062,0 2.11761,-0.40586 2.93011,-1.21835 0.82813,-0.8125 1.24182,-1.79657 1.24182,-2.95282 0,-1.14063 -0.41369,-2.11762 -1.24182,-2.93012 -0.8125,-0.82812 -1.78949,-1.24182 -2.93011,-1.24182 z",
    transform: "matrix(0.68287806,0,0,0.68287806,-343.28744,-37.259104)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreExpired);
export default __webpack_public_path__ + "static/media/PreExpired.602dab0480684ed04b315101207f3c09.svg";
export { ForwardRef as ReactComponent };